import { configureStore, combineReducers } from '@reduxjs/toolkit';
import genbiReducer from './genbiSlice';
import unstructuredThreadReducer from './unstructuredThreadSlice';
import dataFabricReducer from './dataFabricSlice';

const appReducer = combineReducers({
  genbi: genbiReducer,
  unstructuredThread: unstructuredThreadReducer,
  dataFabric: dataFabricReducer,
});

// ── Root reducer: resets entire store on logout ─────────────
// forces every slice reducer to return its own initialState.
const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL_STATE') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;